// components/ui/Tabs.tsx — Radix UI Tabs wrapper

import * as RadixTabs from '@radix-ui/react-tabs';
import styles from './Tabs.module.css';

export interface TabItem {
  value: string;
  label: string;
  content: React.ReactNode;
}

export interface TabsProps {
  value: string;
  onValueChange: (value: string) => void;
  items: TabItem[];
  ariaLabel?: string;
}

export function Tabs({ value, onValueChange, items, ariaLabel }: TabsProps) {
  return (
    <RadixTabs.Root className={styles.root} value={value} onValueChange={onValueChange}>
      <RadixTabs.List className={styles.list} aria-label={ariaLabel}>
        {items.map((item) => (
          <RadixTabs.Trigger key={item.value} className={styles.trigger} value={item.value}>
            {item.label}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {items.map((item) => (
        <RadixTabs.Content key={item.value} className={styles.content} value={item.value}>
          {item.content}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  );
}
